exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".upload-modal-wrapper {\n    background-color: white;\n    height: 25rem;\n    width: 25rem;\n    padding: 2rem;\n    position: fixed; \n    top: 50%; \n    left: 50%; \n    transform: translate(-50%, -50%); \n}\n\n.upload-modal-wrapper .title {\n    font-weight: 600;\n}\n\n.upload-modal-wrapper .progress-wrapper {\n    display: flex;\n    flex-direction: column;\n    height: 82%;\n    border: solid 1px #d8d8d8;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n}\n\n.upload-modal-wrapper .progress-wrapper h5 {\n    font-weight: 600;\n    margin-bottom: 2rem;\n}", ""]);

// exports
